var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-carousel" },
    [
      _vm.isMobile
        ? [
            _c("rb-header-editorial-wall", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [_vm._t("title")]
                    },
                    proxy: true,
                  },
                  {
                    key: "wall-products",
                    fn: function () {
                      return [_vm._t("content")]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ]
        : [
            _c("div", { staticClass: "carousel__header" }, [
              _c("div", [_vm._t("title")], 2),
              _vm._v(" "),
              _c("div", { staticClass: "carousel__controls" }, [
                _c(
                  "span",
                  {
                    ref: "prevNavigation",
                    staticClass: "common__icon common__icon--caret-big-left",
                  },
                  [_vm._v("prev")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.currentGroup) + "/" + _vm._s(_vm.totalGroups)
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    ref: "nextNavigation",
                    staticClass: "common__icon common__icon--caret-big-right",
                  },
                  [_vm._v("next")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "carousel__slides" },
              [
                _c(
                  "rb-smart-container",
                  {
                    attrs: {
                      "slides-per-view-desktop": _vm.slidesPerView,
                      "columns-of-next-slide": 0,
                      "space-between-slides": 32,
                      pagination: false,
                      navigation: false,
                      "slides-per-group": _vm.slidesPerGroup,
                      "next-navigation": _vm.nextNavButton,
                      "prev-navigation": _vm.prevNavButton,
                    },
                    on: {
                      swiperNext: _vm.incrementCurrentGroup,
                      swiperPrev: _vm.decrementCurrentGroup,
                    },
                  },
                  [_vm._t("content")],
                  2
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }